import AdminAPI from 'config/api/AdminAPI';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

import { setModules, setLoading } from '../slices/AdminDynamicModuleSlice';

export const getDynamicModules = () => {
  return async (dispatch: any, getState: any) => {
    const { modules, isLoading } = getState().admin.adminDynamicModule;
    if (isLoading || modules.length > 0) return;

    dispatch(setLoading(true));
    try {
      const response: any = await manageAPICall(
        AdminAPI.dynamicModules.url,
        AdminAPI.dynamicModules.method,
        {}
      );
      if (response && response.status) {
        dispatch(setModules(response.data));
      }
      return response;
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const getDynamicListData = async (moduleName: string, data: object) => {
  const url = AdminAPI.dynamicList.url.replace(':moduleName', moduleName);
  const response = await manageAPICall(url, AdminAPI.dynamicList.method, data);
  return response;
};

export const addDynamicData = async (moduleName: string, data: object) => {
  const url = AdminAPI.dynamicCreate.url.replace(':moduleName', moduleName);
  const response = await manageAPICall(url, AdminAPI.dynamicCreate.method, data);
  return response;
};

export const updateDynamicData = async (moduleName: string, data: object) => {
  const url = AdminAPI.dynamicUpdate.url.replace(':moduleName', moduleName);
  const response = await manageAPICall(url, AdminAPI.dynamicUpdate.method, data);
  return response;
};

export const updateDynamicStatus = async (moduleName: string, data: object) => {
  const url = AdminAPI.dynamicStatus.url.replace(':moduleName', moduleName);
  const response = await manageAPICall(url, AdminAPI.dynamicStatus.method, data);
  return response;
};

export const deleteDynamicData = async (moduleName: string, data: object) => {
  const url = AdminAPI.dynamicDelete.url.replace(':moduleName', moduleName);
  const response = await manageAPICall(url, AdminAPI.dynamicDelete.method, data);
  return response;
};

export const getSingleDynamicInfo = async (moduleName: string, data: object) => {
  const url = AdminAPI.dynamicInfo.url.replace(':moduleName', moduleName);
  const response = await manageAPICall(url, AdminAPI.dynamicInfo.method, data);
  return response;
};
